import { AdvertiseDto } from "../../dto/vending/AdvertiseDto";
import { MachineDto } from "../../dto/vending/MachineDto";
import { OrderInfoDto } from "../../dto/vending/OrderInfoDto";
import vmType, { IVMAction, VMState } from "./vendingmachine.type";

const initialState: VMState = {
    vendingInfo: undefined,
    orderInfo: undefined,
    advertiseList: undefined,
    isLoading: false,
    upStatus: undefined,
    error: undefined,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action: IVMAction) => {
    switch (action.type) {
        // up status
        case vmType.GET_VM_INFO.UP_STATUS:
            return {
                ...state,
                isLoading: false,
                upStatus: action.payload as string,
            };
        // VendingInfo 
        case vmType.GET_VM_INFO.LOADING:
            return {
                ...state,
                isLoading: true,
            };
        case vmType.GET_VM_INFO.SUCCESS:
            return {
                ...state,
                isLoading: false,
                vendingInfo: action.payload as MachineDto,
            };
        case vmType.GET_VM_INFO.CLEAN:
            return {
                ...state,
                isLoading: false,
                vendingInfo: undefined,
            };
        case vmType.GET_VM_INFO.ERROR:
            return {
                ...state,
                isLoading: false,
                vendingInfo: undefined,
                error: action.error,
            };
        // Advertise
        case vmType.ADVERTISE.LOADING:
            return {
                ...state,
            };
        case vmType.ADVERTISE.SUCCESS:
            return {
                ...state,
                advertiseList: (Array.isArray(action.payload) ? action.payload : []) as AdvertiseDto[],
            };
        case vmType.ADVERTISE.CLEAN:
            return {
                ...state,
                advertiseList: undefined,
            };
        case vmType.ADVERTISE.ERROR:
            return {
                ...state,
                advertiseList: undefined,
                error: action.error,
            };
        // getOrderMachineInfo
        case vmType.GET_ORDER_INFO.LOADING:
            return {
                ...state,
                isLoading: true,
            };
        case vmType.GET_ORDER_INFO.SUCCESS:
            return {
                ...state,
                isLoading: false,
                orderInfo: (Array.isArray(action.payload) ? action.payload : []) as OrderInfoDto[],
            };
        case vmType.GET_ORDER_INFO.ERROR:
            return {
                ...state,
                isLoading: false,
                orderInfo: undefined,
                error: action.error,
            };
        default:
            return state;
    }
};
